import React from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function OrderSuccess() {
  const { orderNo } = useParams();
  const [sp] = useSearchParams();
  const isUpi = sp.get("upi") === "1";
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center">
      <div className="w-16 h-16 rounded-full bg-[#D4AF37]/20 flex items-center justify-center mx-auto mb-6">
        <CheckCircle2 size={32} className="text-[#D4AF37]" />
      </div>
      <div className="eyebrow mb-2">Order Placed</div>
      <h1 className="font-serif text-3xl md:text-4xl text-[#0B1F3A]">Thank you — we've got it from here.</h1>
      <p className="text-[#1E293B]/70 mt-4">Your order <span className="font-semibold text-[#0B1F3A]" data-testid="success-order-no">{orderNo}</span>{isUpi ? <> has been received. Payment is <span className="font-semibold" data-testid="success-upi-pending">pending verification</span> — we'll confirm it once your UPI payment is checked.</> : " is confirmed. A copy of the receipt has been sent to your email."}</p>
      <div className="flex gap-3 justify-center mt-8">
        <Link to={`/track/${orderNo}?just_placed=1`} className="bg-[#0B1F3A] text-[#FFF9E6] px-6 py-3 text-sm tracking-widest uppercase" data-testid="track-order-link">Track Order</Link>
        <Link to="/shop" className="border border-[#0B1F3A] text-[#0B1F3A] px-6 py-3 text-sm tracking-widest uppercase" data-testid="continue-shopping">Continue Shopping</Link>
      </div>
    </div>
  );
}
